import Accessor from "esri/core/Accessor";
import { whenOnce } from "esri/core/watchUtils";
import EsriMap from "esri/Map";
import MapView from "esri/views/MapView";
import { setupMapView } from "./setupView";

import { property, subclass } from "esri/core/accessorSupport/decorators";

export interface AppParams {
  appName: string;
  appNotice: string;
  appNoticeStart: string;
  appNoticeEnd: string;
  map: EsriMap;
  view: MapView;
}

@subclass("widgets.App.AppViewModel")
class AppViewModel extends Accessor {
  @property() appName: string;
  @property() appNotice: string;
  @property() appNoticeStart: string;
  @property() appNoticeEnd: string;

  @property() map: EsriMap;

  @property() view: MapView;

  constructor(params?: Partial<AppParams>) {
    super(params);
    whenOnce(this, "view").then(this.onload.bind(this));
  }

  onload() {
    setupMapView(this.view);
  }
}

export default AppViewModel;
